import styled from 'styled-components'

export const DataLabelWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  flex: 1;
  min-width: 0;
`

export const DataLabel = styled.span<{ $hasTooltip?: boolean }>`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
  flex: 1;
  min-width: 0;
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: ${({ $hasTooltip }) => ($hasTooltip ? 'help' : 'default')};

  ${({ $hasTooltip }) =>
    $hasTooltip &&
    `
    &::after {
      content: '';
      width: 13px;
      height: 13px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23999' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Cpath d='M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3'/%3E%3Cdot cx='12' cy='17' r='.5'/%3E%3C/svg%3E");
      background-size: contain;
      opacity: 0;
      transition: opacity 0.2s ease;
    }
    
    &:hover::after {
      opacity: 0.5;
    }
  `}
`

export const HoverExplanation = styled.div`
  position: fixed;
  z-index: 2147483647;
  left: 0;
  top: 0;
  padding: 12px 14px;
  background: rgba(255, 255, 255, 0.98);
  color: ${({ theme }) => theme.colors.text.secondary};
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  font-size: 12px;
  line-height: 1.6;
  font-weight: 400;
  white-space: normal;
  word-wrap: break-word;
  width: 280px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.12),
    0 2px 8px rgba(0, 0, 0, 0.06);
  pointer-events: none;
  animation: fadeIn 0.15s ease-in;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: -6px;
    left: 20px;
    width: 12px;
    height: 12px;
    background: rgba(255, 255, 255, 0.98);
    border-left: 1px solid rgba(0, 0, 0, 0.06);
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    transform: rotate(45deg);
    z-index: -1;
  }
`
